import React from 'react';
import './loader.scss';
import {useLoaderStore} from "../../../store/loader/loader.store";

const Loader = () => {

    const {status, loaderTitle} = useLoaderStore();

    if (!status) {
        return null;
    }

    return (
        <div className="loaderWindow">
            <div className="loaderWindow__box">

                <div className="middle">
                    <div className="bar bar1"></div>
                    <div className="bar bar2"></div>
                    <div className="bar bar3"></div>
                    <div className="bar bar4"></div>
                    <div className="bar bar5"></div>
                    <div className="bar bar6"></div>
                    <div className="bar bar7"></div>
                    <div className="bar bar8"></div>
                </div>

                <h2>{loaderTitle}</h2>
                <span>(it may take few minutes)</span>


            </div>
        </div>
    );
};

export default Loader;
